export default __webpack_public_path__ + "static/media/logo_200.fd0bc99f.png";